import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Footer.css";
const Footer = () => {
  return (
    <div className="bg-dark text-light">

    <div className="container mt-5 pt-5 pb-5">
      <Row lg={4}>
        <Col sm={12}>
          <img style={{ height: "60px" }} src="/logo.svg" alt="" /> <br />
          <span className="mb-3">Sophisticated simplicity for the independent mind.</span>
        </Col>
        <Col sm={12} className=" text-light">
          <small className="mb-3"  style={{fontWeight:"bold",borderBottom:"1px solid gray"}}>Help & Infomation</small> <br /> 
          <Link className="link mt-3" to="/">
            About Us
          </Link>{" "}
          <br />
          <Link className="link" to="/">
            Privacy Policy
          </Link>
          <br />
          <Link className="link" to="/">
            Terms & Conditions
          </Link>
          <br />
          <Link className="link" to="/">
            Products Return
          </Link>
          <br />
          <Link className="link" to="/">
            Wholesale Policy
          </Link>
          <br />
        </Col>
        <Col sm={12}>
          <span style={{fontWeight:"bold",borderBottom:"1px solid gray"}}>About Us
</span> <br />
          <Link className="link" to="/">
          Pagination
          </Link>{" "}
          <br />
          <Link className="link" to="/">
          Terms & Conditions
          </Link>
          <br />
          <Link className="link" to="/">
          Contact
          </Link>
          <br />
          <Link className="link" to="/">
          Accessories
          </Link>
          <br />
          <Link className="link" to="/">
          Term of use
          </Link>
          <br />
        </Col>
        <Col sm={12}>
          <span style={{fontWeight:"bold",borderBottom:"1px solid gray"}}>Categories</span> <br />
          <Link className="link" to="/">
          Help Center
          </Link>{" "}
          <br />
          <Link className="link" to="/">
          Home page
          </Link>
          <br />
          <Link className="link" to="/">
          Privacy Policy
          </Link>
          <br />
          <Link className="link" to="/">
          Receivers & Amplifiers
          </Link>
          <br />
          <Link className="link" to="/">
          Delivery & Returns
          </Link>
          <br />
        </Col>
      </Row>
    </div>
    </div>
  );
};

export default Footer;
